import { render, staticRenderFns } from "./ApproveUser.vue?vue&type=template&id=65a78d12"
import script from "./ApproveUser.vue?vue&type=script&lang=js"
export * from "./ApproveUser.vue?vue&type=script&lang=js"
import style0 from "./ApproveUser.vue?vue&type=style&index=0&id=65a78d12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports